import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const ContactPage = () => {
    return(
        <>
            <Navbar/>
            <Footer/>
        </>
    )
};

export default ContactPage;